module.exports = __webpack_public_path__ + "img/icon_base.d8caffb2.svg";